<template>
<div>
  <div>
    <van-nav-bar
    title="关于我们"
    style="background:linear-gradient(to right,#19CBDA,#2EDD9C);color:#fff"
    >
      <template #left>
        <van-icon name="arrow-left" @click="onClickLeft" color="#fff" size="18" />
      </template>
    </van-nav-bar>
  </div>
  <div class="bg">
<img :src="img" class="imgs" />
  </div>
  <van-cell @click='update' title="版本检测更新" value="3.2v" is-link />
</div>
</template>
<script>
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';
import { NavBar } from 'vant';
import { Toast } from 'vant';
// import {Request} from '../utils/Request'

Vue.use(NavBar);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  name:'AboutUs',
  data(){
    return{
      // img:require('./timg010.jpg')
    }
  },
  methods: {
    onClickLeft() {
      Toast('返回');
    },
    // islogin(values){
    //    if(sessionStorage.getItem('TOKEN') === null){
    //      Request.post('/auth/login/login-by-password',values).then(res=>{
    //       sessionStorage.setItem('TOKEN',res.data.token)
    //       this.$router.push({path: '/'})
    //     }).catch(err=>{

    //     })
    //    }else{
    //     //  this.shart()
    //     this.ActivityDetail(this.activityId)
    //    }
    // },
    update(){
      Toast('当前是最新版本……');
    }
  },
}
</script>
<style scoped>
.bg{
  background: #fff;
  margin-top: 1px;
  margin-bottom:1px;
  padding: 1px;
}
.imgs{
  width:100px;
  height: 100px;
  margin:100px auto;
  display: block;
}
</style>
